module.exports = __webpack_public_path__ + "static/media/negativeImpactIcon.35fa8ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/negativeImpactIcon.png
// module id = 901
// module chunks = 0